import uniqBy from 'lodash/uniqBy';
import { xSelectSingle } from 'utils/xSelect';
import { list } from 'utils/Api';

function mapOptions(obj, { label, value }) {
  return {
    label: obj[label] || '-',
    value: obj[value],
  };
}


/**
  Function that fetches optins for a select field from QData.
  Where prop `field` in the entity equals `fieldValue`,
*/
function selectOptions({
  entity, label, value, token, field, fieldValue, orderByValue,
}) {

  const config = {
    entity,
    headers: { Authorization: `Bearer ${token}` },
    data: fieldValue !== undefined ? xSelectSingle([
      { field, value: fieldValue, relation: 'eq' },
    ]) : '',
  };

  return list(config)
    .then(entityList => uniqBy(entityList.data.map(e => mapOptions(e, { label, value })).sort((a, b) => {
      if (orderByValue) {
        return a.value > b.value;
      }
      return a.label.toString().localeCompare(b.label.toString());
    }), 'value'));
}

export default selectOptions;



// WEBPACK FOOTER //
// ./src/utils/selectOptions.js